import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';

import styles from './styles.module.css';

class SimpleCheckbox extends React.Component {

  constructor(props) {

    super(props);

    this.state = {

      isChecked: false,

    };

    this.handleChange = this.handleChange.bind(this);

  }

  handleChange() {

    this.setState({

      isChecked: !this.state.isChecked,

    });

  }

  render() {

    const flex = this.props.flex === 'column' ? styles.checkboxInputColumn : styles.checkboxInputRow;

    return (
      <div
        className={`form_checkbox_${this.props.index}_${this.props.idx}_${this.props.sectionId} ${flex}`}
      >
        <input
          id={`checkboxOptionGroup_${this.props.index}_${this.props.idx}_${this.props.sectionId}`}
          type="checkbox"
          name={`checkboxOptionGroup_${this.props.index}_${this.props.sectionId}`}
          className={this.props.flex === 'column' ? styles.inputOptionColumn : styles.inputOptionRow}
          value={this.props.value}
          checked={this.state.isChecked}
          data-index={this.props.idx}
          onChange={this.handleChange}
        />
        <label
          htmlFor={`checkboxOptionGroup_${this.props.index}_${this.props.idx}_${this.props.sectionId}`}
        >
          {this.props.value}
        </label>
      </div>
    );

  }

}

SimpleCheckbox.propTypes = {
  value: PropTypes.string,
  index: PropTypes.number,
  idx: PropTypes.number,
  sectionId: PropTypes.string,
  flex: PropTypes.string,
};

export default CSSModules(
  SimpleCheckbox,
  styles,
  { allowMultiple: true },
);
